/** @jsx jsx */

import React, { Fragment as _, useContext } from 'react';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';
import { CarouselContext } from './Carousel';

//

const { lPink, lGrey0, lGrey1, lGrey2 } = colors;

const Marker = ({ size = 10, current = false }) => {
  return (
    <div
      css={css`
        position: relative;
        flex-shrink: 0;
        width: ${size}px;
        height: ${size}px;
        margin: 0 5px;
        background: ${current ? lPink : 'transparent'};
        border: 1px solid ${lPink};
        border-radius: 50%;
        transform: scale(${current ? 1.35 : 1});
        transition: all 0.25s;
      `}
    />
  );
};

const Marker_v2 = ({
  size = 15,
  index,
  current = false,
}: {
  size?: number;
  index?: number;
  current?: boolean;
}) => {
  const carouselContext = useContext(CarouselContext);
  const { goto, animate } = carouselContext;

  // background: rgba(73, 73, 73, ${current ? 1 : 0.45});
  // #959595

  return (
    <div
      css={css`
        position: relative;
        flex-shrink: 0;
        width: ${size}px;
        height: ${size}px;
        margin: 0 5px;
        // background: ${current ? lPink : 'transparent'};
        background: ${current ? 'rgba(73, 73, 73, 1)' : '#959595'};
        // border: 1px solid ${lPink};
        border-radius: 50%;
        // transform: scale(${current ? 1.35 : 1});
        ${animate && 'transition: all 0.25s;'}
        

        ${!current &&
          `
          cursor: pointer;
          &:hover {
            rgba(73, 73, 73, 0.45)
          }
        `}

        @media (max-width: 480px) {
          top: 5px;
          width: ${size / 2}px;
          height: ${size / 2}px;
        }

      `}
      onClick={e => {
        !current && goto(index);
      }}
      aria-label={`Go to slide ${index + 1}`}
      aria-pressed={current}
    />
  );
};

export default Marker_v2;
